import {
  Maybe,
  AsphaltLot,
  DailyInspectionControlPoint,
  DailyInspectionInspection,
  DailyInspectionPunchList,
  Lot,
  IdentifiedFieldIssue,
  ConcreteTest,
} from 'schema'

export function getReport<T extends GetReportIdentifiedFieldIssue>({
  asphaltLot,
  concreteTest,
  dailyInspectionControlPoint,
  dailyInspectionInspection,
  dailyInspectionPunchList,
  lot,
}: T):
  | T['asphaltLot']
  | T['concreteTest']
  | T['dailyInspectionControlPoint']
  | T['dailyInspectionControlPoint']
  | T['dailyInspectionInspection']
  | T['dailyInspectionPunchList']
  | T['lot'] {
  return (
    asphaltLot ??
    concreteTest ??
    dailyInspectionControlPoint ??
    dailyInspectionInspection ??
    dailyInspectionPunchList ??
    lot
  )
}

type GetReportIdentifiedFieldIssue = Pick<
  IdentifiedFieldIssue,
  '__typename'
> & {
  asphaltLot: Maybe<Pick<AsphaltLot, '__typename'>>
  concreteTest: Maybe<Pick<ConcreteTest, '__typename'>>
  dailyInspectionControlPoint: Maybe<
    Pick<DailyInspectionControlPoint, '__typename'>
  >
  dailyInspectionInspection: Maybe<
    Pick<DailyInspectionInspection, '__typename'>
  >
  dailyInspectionPunchList: Maybe<Pick<DailyInspectionPunchList, '__typename'>>
  lot: Maybe<Pick<Lot, '__typename'>>
}
